import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { capabilities } from 'navigation-components/capabilities';
import { useInvokeCapability } from 'navigation-components/consumer/hooks';
export const VIEWPORT_WIDTH = 400;
export const VIEWPORT_HEIGHT = 600;
export const POPOVER_ALERT_WIDTH = 448;
export const ONBOARDING_TOUR_WIDTH = 300;
export const ONBOARDING_TOUR_HEIGHT = 268;
export const PROVIDER_MENU = 'PROVIDER_MENU';
export const CALLING_REMOTE = 'CALLING_REMOTE';
export const ONBOARDING_TOUR = 'ONBOARDING_TOUR';
export const POPOVER_ALERT = 'POPOVER_ALERT';
export const DO_NOT_STYLE = 'DO_NOT_STYLE';
export const IFRAME_STYLE = {
  PROVIDER_MENU,
  CALLING_REMOTE,
  ONBOARDING_TOUR,
  POPOVER_ALERT,
  DO_NOT_STYLE
};
export function useChangeIframeStyle(iframeStyle) {
  const theme = useTheme();
  const changeIframeStyle = useInvokeCapability(capabilities.RESTYLE_CAP);
  useEffect(() => {
    switch (iframeStyle) {
      case DO_NOT_STYLE:
      case POPOVER_ALERT:
        changeIframeStyle({
          style: {
            boxShadow: 'none',
            borderRadius: '0px'
          },
          merge: true
        });
        break;
      case PROVIDER_MENU:
        changeIframeStyle({
          style: {
            boxShadow: theme.boxShadow[100],
            borderRadius: '16px'
          },
          merge: true
        });
        break;
      case ONBOARDING_TOUR:
        changeIframeStyle({
          style: {
            boxShadow: theme.boxShadow[100],
            borderRadius: '0px'
          },
          merge: true
        });
        break;
      case CALLING_REMOTE:
        changeIframeStyle({
          style: {
            boxShadow: theme.boxShadow[100],
            borderRadius: '16px'
          },
          merge: true
        });
        break;
      default:
        break;
    }
  }, [changeIframeStyle, theme.boxShadow, iframeStyle]);
}